import React, { createContext, useContext, useRef, useState } from "react";

const AudioContextCustom = createContext();

export function AudioProvider({ children }) {
  const audioRef = useRef(new Audio());
  const [current, setCurrent] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const play = (music) => {
    if (current?.id !== music.id) {
      audioRef.current.src = `https://live-evo.com/${music.file_path}`;
      audioRef.current.load();
    }
    audioRef.current.play();
    setCurrent(music);
    setPlaying(true);
  };

  const pause = () => {
    audioRef.current.pause();
    setPlaying(false);
  };

  audioRef.current.ontimeupdate = () => {
    setProgress(audioRef.current.currentTime);
    setDuration(audioRef.current.duration || 0);
  };

  audioRef.current.onended = () => {
    setPlaying(false);
  };

  return (
    <AudioContextCustom.Provider
      value={{
        current,
        playing,
        progress,
        duration,
        play,
        pause,
        audioRef,
      }}
    >
      {children}
    </AudioContextCustom.Provider>
  );
}

export function useAudio() {
  return useContext(AudioContextCustom);
}
